'use client';

import React from 'react';

interface PricingLayoutProps {
  children: React.ReactNode;
}

export default function PricingLayout({ children }: PricingLayoutProps) {
  return (
    <div className="pricing-layout min-h-screen bg-[#121212] text-white">
      {/* Custom layout container with isolated scroll context */}
      <main className="relative pt-16">
        {/* The pt-16 ensures content starts below the navbar */}
        {children}
      </main>
    </div>
  );
} 